export default {
  CC_NEW: 'cc_new',
  CC_SAVED: 'cc_saved',
};
